import META from "@adkit.so/meta-pixel";
import * as Sentry from "@sentry/browser";
import type { GatsbyBrowser } from "gatsby";
import React from "react";

import { MetaPixelRoot } from "./src/components/MetaPixelRoot";

const SENTRY_DSN =
  "https://f21f63d549ef45d9ba3f9b24672f2696@sentry.io/1432924";

let isFirstRouteUpdate = true;

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <MetaPixelRoot>{element}</MetaPixelRoot>;

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  Sentry.init({ dsn: SENTRY_DSN });
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
  if (isFirstRouteUpdate) {
    isFirstRouteUpdate = false;
    return;
  }

  if (META.isLoaded()) {
    META.track("PageView");
  }
};
